// Vue plugin <toggla-rader-i-datatable>:

'use strict';

import Vue from 'vue';
import { euiSwitch } from 'v-components/euiSwitch';

Vue.use(euiSwitch);


const plugin = {

	install(Vue, options) {

		Vue.component('toggla-rader-i-datatable', {

			template: `
					<eui-switch :vp-access-key="vpAccessKey" :vp-tooltip="vpTooltip" :vpPaslagen="visaRaderna" :vp-inaktiverad="vpInaktiverad || tabellobjekt === null" @andrad="onAndrad($event)">
						<slot></slot>
					</eui-switch>
				`,
			
			// Vad som ska användas för bindning till den konsumerande app-instansen:
			model: {
				prop: 'visaRaderna',
				event: 'andrad'
			},

			props: {
				vpAccessKey: {
					type: String,
					default: null
				},
				vpTooltip: {
					type: String,			// Får innehålla HTML.
					default: null
				},
				visaRaderna: {
					type: Boolean,
					default: false
				},
				vpInaktiverad: {
					type: Boolean,
					default: false
				},
				kolumnIndex: {
					type: [Number, Array],
					required: true
				},
				filtervardeOmVisa: {
					type: [String, Array],
					default: ''
				},
				filtervardeOmDolj: {
					type: [String, Array],
					default: 'true'
				},
				tabellobjekt: {
					type: Object,
					default: null	// null = inte satt än.
				},

			},

			methods: {
				onAndrad(skaVisas)
				{
					// Arrayifiera om enskilda värden angetts:
					let kolumnIndexArray = (this.kolumnIndex.constructor === Array ? this.kolumnIndex : [this.kolumnIndex]);
					let filtervardeOmVisaArray = (this.filtervardeOmVisa.constructor === Array ? this.filtervardeOmVisa : [this.filtervardeOmVisa]);
					let filtervardeOmDoljArray = (this.filtervardeOmDolj.constructor === Array ? this.filtervardeOmDolj : [this.filtervardeOmDolj]);

					for (let i = 0; i < kolumnIndexArray.length; i++)
					{
						let searchFor = (skaVisas === true ? filtervardeOmVisaArray[i] : filtervardeOmDoljArray[i]);
						this.tabellobjekt.column(kolumnIndexArray[i]).search(searchFor);
					}

					this.tabellobjekt.draw();

					// Obs! Skicka dett event först *efter* att tabellraderna uppdaterats! Varför var det nu så då?? Dålig UX om tabelluppdateringen tar lång tid (lång tabell)! 
					// Till den konsumerande app-instansen (för att bindningen ska funka):
					this.$emit('andrad', skaVisas);
				}
			},

			watch: {
				tabellobjekt(nyttVarde, tidigareVarde)
				{
					if (nyttVarde !== null)
					{
						// Sätt rätt initialt filter på tabellobjektet (för att default för datatable sätts till nåt utanför Vue:s konroll):
						// Todo: Bör kanske åtgärdas!!
						this.onAndrad(this.visaRaderna);
					}
				},
			},

			mounted()
			{
				// Note that mounted does not guarantee that all child components have also been mounted.

				//this.$nextTick(function ()
				//{
				//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
				//})
			}
		});


		// Exempel för en Vue plugin:

		//// 1. add global method or property
		//Vue.myGlobalMethod = function () {
		//	// something logic ...
		//}

		//// 2. add a global asset
		//Vue.directive('my-directive', {
		//	bind(el, binding, vnode, oldVnode) {
		//		// something logic ...
		//	}
		//	// ...
		//})

		//// 3. inject some component options
		//Vue.mixin({
		//	created() {
		//		// something logic ...
		//	}
		//	//...
		//  })

		//// 4. add an instance method
		//Vue.prototype.$myMethod = function (methodOptions) {
		//	// something logic ...
		//}
	}
};

export { plugin as ssoTogglaRaderIDatatable };
